import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';
import FormInput from "../../components/forms/formInput";

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const ExpensesFilter = ({ isFiltering, onFilter }) => {

    const { t } = useTranslation();
    const [isShow, setIsShow] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [category, setCategory] = useState('')
    const [paymentMethod, setPaymentMethod] = useState('')
    const queryClient = useQueryClient()

    const activeCount = [dateFrom, dateTo, category, paymentMethod].filter(Boolean).length

    const handleFilter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onFilter([
            dateFrom ? new Date(dateFrom.setHours(0, 0, 0, 0)) : '',
            dateTo ? new Date(dateTo.setHours(23, 59, 59, 999)) : '',
            category,
            paymentMethod
        ])
    }

    const handleReset = () => {
        onFilter(['', '', '', ''])
        setDateFrom('')
        setDateTo('')
        setCategory('')
        setPaymentMethod('')
        queryClient.invalidateQueries(['expenses','paginated'])
    }

    return (
        <>
            <button type="button" className={`filter-toggle${isShow ? ' on' : ''}`} onClick={() => setIsShow(s => !s)}>
                <FilterIcon /> {t('expenses.filters')}
                {activeCount > 0 && <span className="cnt">{activeCount}</span>}
                <ChevIcon />
            </button>

            {isShow && (
                <Form onSubmit={handleFilter} className="filter-panel">
                    <div className="filter-grid">
                        <DatePicker className="form-control" label={t('expenses.dateFromLabel')} placeholderText={t('expenses.anyStartDate')}
                            selected={dateFrom} onChange={setDateFrom} maxDate={dateTo || undefined} dateFormat="dd.MM.yyyy" />
                        <DatePicker className="form-control" label={t('expenses.dateToLabel')} placeholderText={t('expenses.anyEndDate')}
                            selected={dateTo} onChange={setDateTo} minDate={dateFrom || undefined} dateFormat="dd.MM.yyyy" />
                        <FormInput value={category} label={t('expenses.categoryLabel')} size="md" onChange={(e) => setCategory(e.target.value)} />
                        <FormInput value={paymentMethod} label={t('expenses.paymentMethodLabel')} size="md" onChange={(e) => setPaymentMethod(e.target.value)} />
                    </div>

                    <div className="filter-foot">
                        <span className="meta">
                            {activeCount > 0 ? (activeCount > 1 ? t('expenses.filtersSelectedPlural', { count: activeCount }) : t('expenses.filtersSelected', { count: activeCount })) : t('expenses.noFiltersApplied')}
                        </span>
                        <div className="sp">
                            <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={handleReset}>{t('expenses.reset')}</button>
                            <button type="submit" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isFiltering}>
                                {isFiltering ? t('expenses.filtering') : t('expenses.applyFilters')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </>
    )
}

export default ExpensesFilter
